import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
const Skeleton = ({ className, width, height, borderRadius }) => {
    const { Skeleton: css } = useTheme('Shared');
    return React.createElement("div", { className: cn(css.skeleton, className), style: { width, height, borderRadius } });
};
export default Skeleton;
